import { render, staticRenderFns } from "./TransactionForm.vue?vue&type=template&id=471ccfac&scoped=true&"
import script from "./TransactionForm.vue?vue&type=script&lang=js&"
export * from "./TransactionForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=471ccfac&scoped=true&lang=css&"
import style1 from "./TransactionForm.vue?vue&type=style&index=1&id=471ccfac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ccfac",
  null
  
)

export default component.exports